import { Stack } from '@mui/material';
import React from 'react';

import AdType from './fields/AdType';
import Api from './fields/Api';
import Associated from './fields/Associated';
import Category from './fields/Category';
import CustomSchedule from './fields/CustomSchedule';
import Name from './fields/Name';
import Size from './fields/Size';
import ThirdPartyTagIds from './fields/ThirdPartyTagIds';
import Variables from './fields/Variables';
import AdParameters from './fields/videoAd/AdParameters';
import AdSystem from './fields/videoAd/AdSystem';
import AdTitle from './fields/videoAd/AdTitle';
import Duration from './fields/videoAd/Duration';
import Mimes from './fields/videoAd/Mimes';
import VastAdTagUri from './fields/videoAd/VastAdTagUri';

interface WrapperVideoProps {
  adGroupId?: number;
}

function WrapperVideo({ adGroupId }: WrapperVideoProps) {
  return (
    <Stack spacing={2}>
      <Name />
      {Boolean(adGroupId) && <Associated />}
      <Category />
      <Stack direction="row" spacing={2}>
        <Size readOnly defaultValue="Video Ad" />
        <AdType />
        <Api />
      </Stack>
      <AdTitle />
      <Duration />
      <Mimes />
      <VastAdTagUri />
      <AdSystem />
      <ThirdPartyTagIds />
      <Variables />
      <AdParameters />
      <CustomSchedule />
    </Stack>
  );
}

export default WrapperVideo;
